<app-tab>
  <dx-data-grid
    id="usersGridContainer"
    [dataSource]="ds"
    [libGridDefault]="{stateStorageKey: 'app-users-grid'}"
    [columnHidingEnabled]="false"
    (onEditingStart)="onEdit($event)"
    (onInitNewRow)="onCreate()"
    [libGridTitle]="{text: 'Utilisateurs'}">

    <dxi-column
      caption="ID"
      dataField="id"
      sortOrder="desc"
      width="6%"
      [allowEditing]="false"
      [formItem]="{visible: false}"
      dataType="number">
    </dxi-column>

    <dxi-column
      caption="Nom"
      dataField="name"
      dataType="string">
      <dxi-validation-rule type="required"></dxi-validation-rule>
      <dxi-validation-rule type="stringLength" [min]="5" [max]="255"></dxi-validation-rule>
    </dxi-column>

    <dxi-column
      caption="Photo"
      dataField="photo"
      cssClass="photo-cell"
      [allowExporting]="false"
      [allowSorting]="false"
      [allowFiltering]="false"
      cellTemplate="photoTemplate"
      editCellTemplate="photoEditor"
      dataType="string">
      <div *dxTemplate="let cellInfo of 'photoEditor';">
        <lib-profile-photo-upload
          [value]="cellInfo.value"
          (valueChange)="cellInfo.setValue($event)"></lib-profile-photo-upload>
      </div>
    </dxi-column>

    <div *dxTemplate="let userCell of 'photoTemplate'">
      <div class="photo" [style.backgroundImage]="'url(\'' + userCell.data.photoUrl() + '\')'"></div>
    </div>

    <dxi-column
      caption="Email"
      dataField="email"
      dataType="string">
      <dxi-validation-rule type="required"></dxi-validation-rule>
      <dxi-validation-rule type="email"></dxi-validation-rule>
      <dxi-validation-rule type="stringLength" [min]="5" [max]="255"></dxi-validation-rule>
      <dxi-validation-rule type="async" message="Email existe déjà"
                           [validationCallback]="emailValidation"></dxi-validation-rule>
    </dxi-column>

    <dxi-column
      caption="Téléphone"
      dataField="phone"
      dataType="string">
      <dxo-form-item
        [editorOptions]="{mask: '+212 0 00 00 00 00', maskRules: phonePattern, useMaskedValue:true}"></dxo-form-item>
      <dxi-validation-rule type="required"></dxi-validation-rule>
      <dxi-validation-rule type="pattern" [pattern]="phonePattern"></dxi-validation-rule>
      <dxi-validation-rule type="stringLength" [max]="45"></dxi-validation-rule>
    </dxi-column>

    <dxi-column
      caption="Role"
      dataField="role_name"
      dataType="string">
      <dxo-lookup
        [dataSource]="roles | async"
        valueExpr="name"
        displayExpr="name">
      </dxo-lookup>
    </dxi-column>

    <dxi-column
      caption="Domaines"
      dataField="domain_names"
      [allowSorting]="false"
      calculateDisplayValue="domain_names"
      [calculateFilterExpression]="calculateFilterExpression"
      [allowEditing]="false"
      [formItem]="{visible: false}"
      dataType="string">
      <dxo-lookup
        [dataSource]="domains"
        valueExpr="name"
        displayExpr="name">
      </dxo-lookup>
    </dxi-column>

    <dxi-column
      caption="Date création"
      [allowEditing]="false"
      [formItem]="{visible: false}"
      dataField="created_at"
      format="shortDateShortTime"
      dataType="date">
    </dxi-column>

    <dxi-column
      caption="Date modification"
      [allowEditing]="false"
      [formItem]="{visible: false}"
      dataField="updated_at"
      format="shortDateShortTime"
      dataType="date">
    </dxi-column>

    <dxi-column type="buttons" [width]="110">
      <dxi-button
        hint="Envoyer un nouveau mot de passe"
        icon="message"
        [visible]="canSendPassword"
        [onClick]="sendNewPassword"></dxi-button>
      <!--<dxi-button hint="Imiter"
                  icon="key"
                  [visible]="canImpersonate"
                  [onClick]="impersonateUser"></dxi-button>-->
      <dxi-button name="edit"></dxi-button>
      <dxi-button name="delete"></dxi-button>
    </dxi-column>

    <dxi-column dataField="role_id"
                caption="Role"
                editCellTemplate="roleEditor"
                [showInColumnChooser]="false"
                [allowFiltering]="false"
                [allowSearch]="false"
                [visible]="false">
      <div *dxTemplate="let cellInfo of 'roleEditor';">
        <lib-role-selector-dropdown [value]="cellInfo.value" (valueChange)="cellInfo.setValue($event)"
                                    [roles]="roles | async"></lib-role-selector-dropdown>
      </div>
      <dxi-validation-rule type="required"></dxi-validation-rule>
    </dxi-column>

    <dxi-column dataField="domains"
                caption="Domains"
                editCellTemplate="domainEditor"
                [showInColumnChooser]="false"
                [allowFiltering]="false"
                [allowSearch]="false"
                [visible]="false">
      <div *dxTemplate="let cellInfo of 'domainEditor';">
        <lib-domains-selector-dropdown [title]="isNew ?  'Les domaines' : current?.name + ' - ' + current?.role_name" [domains]="domains" [value]="cellInfo.value" (valueChange)="cellInfo.setValue($event)"></lib-domains-selector-dropdown>
      </div>
      <dxi-validation-rule type="required"></dxi-validation-rule>
    </dxi-column>

    <dxo-editing
      mode="popup"
      [allowDeleting]="canDelete"
      [allowAdding]="canAdd"
      [allowUpdating]="canEdit">

      <dxo-popup
        [title]="isNew ?  'Ajouter un utilisateur' : current?.name"
        [showTitle]="true"
        width="50%"></dxo-popup>

      <dxo-form [colCount]="4">
        <dxi-item itemType="group">
          <dxi-item dataField="photo">
            <dxo-label [visible]="false"></dxo-label>
          </dxi-item>
        </dxi-item>
        <dxi-item itemType="group" [colSpan]="3" [colCount]="2" caption="Données Personnelles">
          <dxi-item dataField="name"></dxi-item>
          <dxi-item dataField="phone"></dxi-item>
          <dxi-item dataField="email"></dxi-item>
          <dxi-item dataField="role_id"></dxi-item>
          <dxi-item [colSpan]="2" dataField="domains"></dxi-item>
        </dxi-item>
        <dxi-item itemType="group" [colSpan]="4">
          <div *dxTemplate>
            <p *ngIf="isNew" class="text-sm font-light p-1 text-gray-500">Note: Le mot de passe sera généré
              automatiquement et envoyé à l'utilisateur par e-mail.</p>
          </div>
        </dxi-item>
      </dxo-form>
    </dxo-editing>

    <dxo-column-chooser [enabled]="true" mode="select"></dxo-column-chooser>

    <dxo-group-panel [visible]="false"></dxo-group-panel>

    <dxo-export [enabled]="true" fileName="liste-utilisateurs"
                [allowExportSelectedData]="true"></dxo-export>

    <dxo-sorting mode="multiple"></dxo-sorting>

    <dxo-selection
      selectAllMode="page"
      mode="multiple"
    ></dxo-selection>

    <dxo-paging [pageSize]="25"></dxo-paging>
    <dxo-pager
      [showPageSizeSelector]="true"
      [allowedPageSizes]="[25, 50, 100]"
      [showInfo]="true">
    </dxo-pager>
    <dxo-filter-row
      [visible]="true"></dxo-filter-row>
    <dxo-search-panel
      [visible]="true"
      [width]="240"></dxo-search-panel>
    <dxo-header-filter
      [visible]="true"></dxo-header-filter>

  </dx-data-grid>
</app-tab>

